// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__Y0_51","row":"Node_row__1IGCN","label":"Node_label__2IUm_","footer":"Node_footer__1jYtB"};